export const createMediaDataRoomDatasetsQueryKey = (dataRoomId: string) => [
  "v3",
  "mediaDataRoom",
  dataRoomId,
  "datasets",
];
